export default __webpack_public_path__ + "static/media/l.0ac8a8da.jpg";